module.exports = __webpack_public_path__ + "img/romania.79cfca54.svg";